document.addEventListener("turbo:load", function () {
  var trustpilot = document.getElementById('trustpilot');
  if (trustpilot) {
    window.Trustpilot.loadFromElement(trustpilot);
  } else {
    return;
  }
});